import './../../styles/templates/404.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.init404Template = container => {
  if (!container) return;
  var fetchResponse;

  const recommendationsContainer = container.querySelector('.page-404__related-products');
  if (recommendationsContainer) {
    const term = location.pathname.split('/').pop();
    fetch(`${Shopify.routes.root}search/suggest?q=${term}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&section_id=product-recommendations`)
      .then(response => {
        fetchResponse = response;
        return response.text();
      })
      .then(suggestions => {
        if (!fetchResponse.ok) {
          throw new Error(`${fetchResponse.status}: ${suggestions}`);
        }

        recommendationsContainer.innerHTML = suggestions;
        if (typeof window.dAgency !== 'undefined') {
          if (typeof window.dAgency.initCarouselBanner !== 'undefined' && recommendationsContainer.querySelector('.carousel-banner-container')) {
            window.dAgency.initCarouselBanner(recommendationsContainer);
          }

          if (typeof window.dAgency.initProductTile !== 'undefined') {
            recommendationsContainer.querySelectorAll('.product-tile__container').forEach(tile => {
              window.dAgency.initProductTile(tile);
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

if (document.readyState != "loading") {
  const container = document.querySelector('.page-404__container');
  if (container) {
    window.dAgency.init404Template(container);
  }
} else {
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.page-404__container');
    if (container) {
      window.dAgency.init404Template(container);
    }
  });
}
